<template>
    <div class="cc-theme" :data-country="user.deliveryAddress.country" :class="'country-'+user.deliveryAddress.country">
        <div class="cc-theme__alerts" v-if="!display">
            <div class="cc-alert cc-alert--empty-cart">{{ translations['Your shopping cart is empty'] }}</div>
        </div>
        <div class="cc-theme__quick-recap" v-if="display">
            <quick-recap/>
        </div>
        <div class="cc-theme__information" v-if="display">
            <div class="cc-theme__country">
                <country/>
            </div>
            <div class="cc-theme__carriers">
                <carriers/>
            </div>
            <div class="cc-theme__payments">
                <payments/>
            </div>
            <div class="cc-theme__address">
                <delivery-information/>
            </div>
        </div>
        <div class="cc-theme__recap" v-if="display">
            <contact/>
            <recap @finishOrder="finishOrder"/>
        </div>
        <div class="cc-theme__price-recap" v-if="display">
            <contact/>
            <price-recap @finishOrder="finishOrder"/>
        </div>
        <div class="cc-theme__payment-hooks">
            <div id="paymentshooks" v-html="paymentHooks"></div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    import Country from "./Country";
    import Carriers from "./Carriers";
    import Payments from "./Payments";
    import DeliveryInformation from "./DeliveryInformation";
    import Contact from "./Contact";
    import Recap from "./Recap";
    import QuickRecap from "./QuickRecap";
    import PriceRecap from "./PriceRecap";

    export default {
        components: {
            Country,
            Carriers,
            Payments,
            DeliveryInformation,
            Contact,
            Recap,
            QuickRecap,
            PriceRecap,
        },
        computed: {
            ...mapState({
                translations: state => state.translations,
                products: state => state.products,
                selectedCarrier: state => state.selectedCarrier,
                currentCarrier: state => state.currentCarrier,
                selectedPayment: state => state.selectedPayment,
                currentPayment: state => state.currentPayment,
                carriersPaymentsMap: state => state.carriersPaymentsMap,
                paymentHooks: state => state.paymentHooks,
                config: state => state.config,
                consents: state => state.consents,
                user: state => state.user,
                minimalPurchase: state => state.config.minimal_purchase_required,
            }),
            display: function () {
                return this.products && this.products.length;
            },
        },
        methods: {
            finishOrder: function () {
                if (this.minimalPurchase) {
                    return;
                }
                this.showLoading();

                if (this.config.consents.type === 'checkbox' && (this.consents.termsOfService === false || this.consents.privacyPolicy === false)) {
                    this.$store.commit('SET_CONSENT_TERMS_OF_SERVICE_ERROR', this.translations['You must accept the terms and conditions']);
                    this.hideLoading();
                    return;
                }

                const that = this;

                return this.$store.dispatch('FINISH_ORDER')
                    .then((data) => {
                        if (!that.selectedCarrier) {
                            document.querySelectorAll('.cc-carrier').forEach(item => {
                                item.classList.add('cc-invalid')
                            });

                            document.querySelector('.cc-carriers').scrollIntoView({
                                behavior: "smooth",
                                block: "start",
                            });

                            that.hideLoading();

                            return;
                        } else {
                            document.querySelectorAll('.cc-carrier').forEach(item => {
                                item.classList.remove('cc-invalid')
                            });
                        }

                        if (!that.selectedPayment) {
                            document.querySelectorAll('.cc-payment').forEach(item => {
                                item.classList.add('cc-invalid')
                            });

                            document.querySelector('.cc-payments').scrollIntoView({
                                behavior: "smooth",
                                block: "start",
                            });

                            that.hideLoading();

                            return;
                        } else {
                            document.querySelectorAll('.cc-payment').forEach(item => {
                                item.classList.remove('cc-invalid')
                            });
                        }

                        if (that.$store.getters.hasUserError) {
                            const erroneousInput = document.querySelector('.cc-invalid');

                            erroneousInput.parentNode.scrollIntoView({
                                behavior: "smooth",
                                block: "start",
                            });

                            that.hideLoading();

                            return;
                        }

                        if (!(that.selectedCarrier in that.carriersPaymentsMap) || !that.carriersPaymentsMap[that.selectedCarrier]) {
                            alert(that.translations['Invalid carrier/payment combination']);
                            that.hideLoading();
                            return;
                        }

                        const carriersPaymentsMapElement = that.carriersPaymentsMap[that.selectedCarrier];

                        const selectedPayment = carriersPaymentsMapElement.filter(item => {
                            return that.currentPayment.name === item.payment;
                        });

                        if (selectedPayment.length < 1) {
                            alert(that.translations['Invalid carrier/payment combination']);
                            that.hideLoading();
                        }

                        if (data.status === 'error') {
                            alert(data.message);
                            that.hideLoading();
                        }
                    }).catch((error) => {
                        that.hideLoading();
                    })
            },
            showLoading: function () {
                const body = document.getElementsByTagName('body')[0];
                const coverSpin = document.createElement('div');
                coverSpin.id = 'cart-cover-spin';
                body.appendChild(coverSpin);
            },
            hideLoading: function () {
                document.getElementById('cart-cover-spin').remove();
            },
        },
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/components/theme";
</style>
